// import logo from './logo.svg';
// import './App.css';
import React, {useEffect, useState, useRef} from 'react';
import PageInfoStore from './flux/PageInfoStore';

export default function MainSubNavChild(props) {
  const parentHandle = props.parentHandle;
  const subCat = props.subCat;
  const [showChildren, setShowChildren] = useState(false);
  const grandchildren = useRef();
  let subCatTitle = subCat.title.replaceAll('&amp;', '&');
  subCatTitle = subCatTitle.replaceAll('&#39;', "'");

    useEffect(() => {
        const menuHeights = PageInfoStore.getMenuHeights();
        if (grandchildren.current) {
            // add height to menu for CSS animation:
            const totalHeight = grandchildren.current.clientHeight + menuHeights[parentHandle];
            PageInfoStore.setMenuHeights(parentHandle, totalHeight);
        }
    }, [showChildren, parentHandle]);
  
  function showChildList(cats) {
    return (
      <ul className="grandchildren" ref={grandchildren}>
        {cats.map((cat) => {
          const title = cat.title.replaceAll('&amp;', '&');
          return (
            <li>
              <a href={cat.url}>
                {title}
              </a>
            </li>
          )
        })}
      </ul>
    )
  }

  function hasChildren() {
    return (
      <span>
        <a 
          href={subCat.url}
          onClick={((e) => {
            if (!showChildren) {
              e.preventDefault();
              setShowChildren(true);
            }
          })}
        >
          {subCatTitle} <span class="arr"></span>
        </a>
        {showChildren ? showChildList(subCat.children) : ''}
      </span>
    )
  }

  function noChildren() {
    return (
      <a href={subCat.url}>
        {subCatTitle}
      </a>
    )
  }

  return (
    <li>
      {subCat.children.length > 0 ? hasChildren() : noChildren()}
    </li>
  )  

}